import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import * as PanelManager from 'assets/core/js/module/panelManager'
import initSearchFiltersSidePanel from './side-panels/searchFilters'
import type SidePanel from '@design/objects/side-panel/twig/assets/index'

export default function (): void {
  initSearchFiltersSidePanel()

  document.body.addEventListener('close-all-modals', () => {
    document
      .querySelectorAll<HTMLElement>('.accommodation__side-panel, .accommodation__pitch-side-panel, .search-filters__side-panel')
      .forEach((el) => {
        ElementPropertiesManager.getProperty<SidePanel>(el, 'sidePanel')?.close()
      })

    PanelManager.getAll().forEach((el) => {
      el.close()
    })
  })
}
